module.exports = __webpack_public_path__ + "static/img/donationM.f5ce88c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/donationM.png
// module id = Hegs
// module chunks = 1